/**
 * バリデーションのリスト
 *
 * 【使い方イメージ】
 * import { RULE_LIST } from "@/assets/js/const";
 *
 * export default {
 *   data: () => ({
 *     rules: RULE_LIST,
 */
export const RULE_LIST = {
  // 入力必須の制約
  required: (value) => !!value || '必ず入力してください',
  requiredArray: (value) => (!!value && value.length > 0) || '必ず入力してください',

  // ログインID文字列長
  loginIdLength: (value) =>
    value === null || (5 <= value.length && value.length <= 128) || '5文字以上128文字以内で入力してください',
  // ログインID文字列パターン
  loginIdPattern: (value) =>
    value === null ||
    /^[0-9,a-z,_,@,.,-]*$/.test(value) ||
    '小文字の英数字、アンダースコア、アットマーク、ドット、ハイフンのみ入力してください',

  // パスワード文字列長
  passwordLength: (value) => value === null || value.length <= 254 || '254文字以内で入力してください',

  // 新パスワード文字列長
  minLength: (value) =>
    value === null || (8 <= value.length && value.length <= 254) || '文字列は8文字以上で入力してください',

  // 新パスワード数字使用
  containsNumber: (value) => /[0-9]/.test(value) || '数字を1文字以上含めてください',

  // 新パスワードアルファベット小文字使用
  containsLowercase: (value) => /[a-z]/.test(value) || 'アルファベットの小文字を1文字以上含めてください',

  // 検索用ユーザー名
  searchUserNameLength: (value) => value === null || value.length <= 20 || '20文字以内で入力してください',
  // ユーザー名
  usernameLength: (value) =>
    value === null ||
    (String(value).trim().length >= 1 && value.length <= 20) ||
    '1文字以上かつ20文字以内で入力してください',

  // ユーザー種別
  userType: (value) => !!value || value === 0 || '必ず入力してください',

  // 組合員番号
  unionistNo: (value) => {
    const min = 0,
      max = 999999999;
    const digits = 9;
    let result = false;
    const valueLength = String(value).length;
    if (valueLength > digits) {
      return result || `${digits}桁以内で入力してください`;
    }
    if (Number.isFinite(value)) {
      result = min <= value && value <= max;
    } else {
      const n = Number(value);
      result = isNaN(n) ? false : min <= n && n <= max;
    }
    return result || `${min}から${max}までの範囲で入力してください`;
  },

  // 組合員名
  unionistNameLength: (value) =>
    value === null || (String(value).trim().length >= 1 && value.length <= 50) || '50文字以内で入力してください',

  // カードID文字列長
  cardIdLength: (value) => value === null || value.length <= 20 || '20文字以内で入力してください',
  // カードID文字列パターン
  cardIdPattern: (value) => value === null || /^[0-9,-]+$/.test(value) || '数字、半角ハイフンのみ入力してください',

  // カードタイプ
  cardType: (value) => !!String(value) || '必ず入力してください',

  // メールアドレス文字列長
  emailAddressLength: (value) => value == null || value.length <= 254 || '254文字以内で入力してください',
  // メールアドレス文字列パターン
  emailAddressPattern: (value) =>
    !value ||
    /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      value
    ) ||
    'E-mailの形式で入力してください',

  // メール件名文字列長
  emailSubjectLength: (value) => value === null || value.length <= 60 || '60文字以内で入力してください',

  // メール本文文字列長
  emailBodyLength: (value) => value === null || value.length <= 4000 || '4000文字以内で入力してください',

  // スライドリンク文字列長
  slideLinkLength: (value) => value == null || value.length <= 256 || '256文字以内で入力してください',
  // スライドリンク文字列パターン
  slideLinkPattern: (value) =>
    !value ||
    /^https?:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#\u3000-\u30FE\u4E00-\u9FA0\uFF01-\uFFE3]+/g.test(value) ||
    /^\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#\u3000-\u30FE\u4E00-\u9FA0\uFF01-\uFFE3]+/g.test(value) ||
    '外部リンクの場合はURL、内部リンクの場合は絶対パスを指定してください',

  // スライド番号
  slideNo: (value) => {
    const min = 1,
      max = 99;
    let result = false;
    if (Number.isFinite(value)) {
      result = min <= value && value <= max;
    } else {
      const n = Number(value);
      result = isNaN(n) ? false : min <= n && n <= max;
    }
    return result || `${min}から${max}までの範囲で入力してください`;
  },

  // スライド文言文字列長
  slideBodyLength: (value) => value == null || value.length <= 256 || '256文字以内で入力してください',

  // お知らせ（全体/個別）タイトル文字列長
  newsTitleLength: (value) => value == null || value.length <= 22 || '22文字以内で入力してください',
  // お知らせ（全体/個別）文言文字列長
  newsBodyLength: (value) => value == null || value.length <= 256 || '256文字以内で入力してください',
  // お知らせ（全体/個別）リンク文字列長
  newsLinkLength: (value) => value == null || value.length <= 256 || '256文字以内で入力してください',
  // お知らせ（全体/個別）リンク文字列パターン
  newsLinkPattern: (value) =>
    !value ||
    /^https?:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#\u3000-\u30FE\u4E00-\u9FA0\uFF01-\uFFE3]+/g.test(value) ||
    /^\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#\u3000-\u30FE\u4E00-\u9FA0\uFF01-\uFFE3]+/g.test(value) ||
    '外部リンクの場合はURL、内部リンクの場合は絶対パスを指定してください',
};
